import type { ReactElement } from 'react';

export function AppFooter(): ReactElement {
  return (
    <footer className="app-footer" role="contentinfo">
      <p>Powered by AFY Solutions</p>
    </footer>
  );
}
